<script setup>
import LottiePlayer from '~/components/globals/LottiePlayer.vue'
defineProps({ desktopUrl: { type: String, default: '' }, mobileUrl: { type: String, default: '' }, active: { type: Boolean, default: false } })
</script>
<template><LottiePlayer :desktop-url="desktopUrl" :mobile-url="mobileUrl" :active="active" /></template>
